import type { TFunction } from 'i18next'

import { Text } from '@enechain/ecloud-designsystem'

import type { MasterDataTableColumn } from '~/components/common/MasterDataTable'
import { formatJstDateTimeHm } from '~/models/dateTime'
import type { ContractorRow } from '~/pages/CustomerInfo/models/types'

/** 請求書の送付先の一覧表示 (郵便番号 + 住所。 未登録は空文字)。 */
const billingAddressLabel = (row: ContractorRow): string =>
  [row.contractor.billingPostalCode, row.contractor.billingAddress]
    .filter((part) => part !== '')
    .join(' ')

/** 契約者一覧の列。 操作列は表側 (`renderRowActions`) で足す。 */
export const buildContractorColumns = (
  t: TFunction,
  resolveMemberName: (memberId: string | undefined) => string | undefined,
): Array<MasterDataTableColumn<ContractorRow>> => {
  const none = t('page:customerInfo.common.none')
  return [
    {
      key: 'name',
      header: t('page:customerInfo.contractors.table.name'),
      cell: (row) => (
        <Text
          as="span"
          title={
            row.customerNames === ''
              ? t('page:customerInfo.contractors.table.noCustomers')
              : t('page:customerInfo.contractors.table.customersTitle', {
                  names: row.customerNames,
                })
          }
        >
          {row.contractor.name}
        </Text>
      ),
    },
    {
      key: 'customerCount',
      header: t('page:customerInfo.contractors.table.customerCount'),
      format: 'number',
      cell: (row) => row.customerCount.toLocaleString('ja-JP'),
    },
    {
      key: 'supplyPointCount',
      header: t('page:customerInfo.contractors.table.supplyPointCount'),
      format: 'number',
      cell: (row) => row.supplyPointCount.toLocaleString('ja-JP'),
    },
    {
      key: 'billingAddress',
      header: t('page:customerInfo.contractors.table.billingAddress'),
      cell: (row) => (
        <Text as="span" title={row.contractor.billingAttention || undefined}>
          {billingAddressLabel(row) === '' ? none : billingAddressLabel(row)}
        </Text>
      ),
    },
    {
      key: 'updatedAt',
      header: t('page:customerInfo.contract.column.updatedAt'),
      nowrap: true,
      cell: (row) => formatJstDateTimeHm(row.contractor.updatedAt),
    },
    {
      key: 'updatedBy',
      header: t('page:customerInfo.contract.column.updatedBy'),
      nowrap: true,
      cell: (row) => resolveMemberName(row.contractor.updatedBy) ?? none,
    },
  ]
}
